export default __webpack_public_path__ + "static/media/vid3.03bd959d.mov";